module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.160d3f04.png";